import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonService } from '@app/_services';
import { Router, ActivatedRoute } from '@angular/router';
import { TestsuiteService } from '../testsuite.service';

import { TestCaseService } from '../../testcase/testcase.service';
import { constants } from '@assets/data/constants';

import { ToastrService } from 'ngx-toastr';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: "app-testsuite-associate",
  templateUrl: "./testsuite-associate.component.html",
  styleUrls: ["./testsuite-associate.component.less"],
})

export class TestsuiteAssociateComponent implements OnInit {

  moduleDetails: any = {};
  moduleType;
  jiraDefect: any = {};
  openFilter: boolean = true;

  testCaseSearchForm: FormGroup;
  submitted: boolean = false;
  myProjectsList = [];
  configure: object;
  headerkey = '';
  headerVal = '';
  requestHeadersBulk = '';
  thinkTime: any;
  loadTestType: any;
  collectionSize: any;
  page = 1;
  pageSize = 15;
  testcaseList: any = [];
  selectedTestCases: any = [];
  updateData;
  retryToALL;
  delayToAll: any;
  testSuiteDetails: any;
  isTSEdit = false;
  constants = constants;
  allowReviewedTestCases = false;
  webAutomationTool = 'SELENIUM'


  constructor(
    private formBuilder: FormBuilder,
    private _commonServices: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private testsuiteservice: TestsuiteService,
    private testcaseservice: TestCaseService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.myProjects();
    this.route.params.subscribe(() => {
      this.moduleType = this.route.snapshot.data['type'];
      this.moduleDetails = this.route.snapshot.data['details'].response;

    });
    if (this.route.snapshot.routeConfig.path === ':id/associate') {
      this.isTSEdit = true;
      this.testSuiteDetails = this.route.snapshot.data.details.response;
      this.getEndpointById(this.route.snapshot.params.id);
      this.testsuiteservice.getTestSuiteTestCases(this.route.snapshot.params.id).subscribe((data: any) => {
        this.selectedTestCases = data.response;
        if (this.selectedTestCases == null) {
          this.selectedTestCases = [];
        }
      });
    }
    this.setEndpointSearchForm();
    this.pagination();
  }



  filterDesktopEP(value: boolean) {
    this.testCaseSearchForm.get('desktopTestCase').setValue(value);
    this.pagination();
  }
  setEndpointSearchForm() {
    this.testCaseSearchForm = this.formBuilder.group({
      keyword: [null],
      projectIds: [null],
      certified: [null],
      nonFunctional: [null],
      reviewed: [null],
      desktopTestCase: this.testSuiteDetails ? this.testSuiteDetails.desktopTestSuite : this.updateData.desktopTestSuite,
      mobileTestCase: this.testSuiteDetails ? this.testSuiteDetails.mobileTestSuite : this.updateData.mobileTestSuite,
    });
  }

  /* Getting endpoint details by id */
  private getEndpointById(id) {
    this.testsuiteservice.getTestSuiteDetails(id).subscribe(data => {
      this.webAutomationTool = data.response.project.projectConfig.webConfig.WEB_AUTOMATION_TOOL;
      this.updateData = data.response;
    });
  }

  myProjects() {
    this._commonServices.getMyProjects().pipe().subscribe(data => {
      this.myProjectsList = data.response;
      if(this.testSuiteDetails !== undefined) {
        let currentProject: any = this.myProjectsList.filter((ele => ele.id === this.testSuiteDetails.project.id));
        this.allowReviewedTestCases = currentProject[0].allowReviewedTestCases;
      }
    });
  }

  onChange(value: boolean){
    this.testCaseSearchForm.get('mobileTestCase').setValue(value);
    this.pagination();
  }

  onClearFilter() {
    this.setEndpointSearchForm();
    this.pagination();
  }

  pagination() {
    let searchParams = this.testCaseSearchForm.value;
    const collection = {
      page: this.page || 1,
      size: this.pageSize || 8
    };
    searchParams = { ...collection, ...searchParams };
    this.testcaseservice.getTestCaseList(searchParams).subscribe((data: any) => {
      if (data.code === 200) {
        this.collectionSize = data.response.count;
        this.testcaseList = data.response.testCases;
      } else {
        this.collectionSize = 0;
        this.testcaseList = [];
      }
    });
  }

  changeDelayToAll(value) {
    if (null == value || value < 0) {
      return;
    }
    if (this.selectedTestCases.length > 0) {
      this.selectedTestCases.forEach((item) => {
        item.delay = value;
      });
    }
  }

  changeRetryToAll() {
    if (null == this.retryToALL || this.retryToALL > 3) {
      this.retryToALL = 0;
      return;
    }
    if (this.selectedTestCases.length > 0) {
      this.selectedTestCases.forEach((item) => {
        item.reTry = this.retryToALL;
      });
    }
  }

  onPageChange(page: number) {
    this.page = page;
    this.pagination();
  }

  onSizeChange() {
    this.pagination();
  }

  addToAssocTestCase(item: any) {
    
    const obj = {
      sequenceNumber: null,
      testCaseId: item.id,
      name: item.name,
      certified: item.certified,
      nonFunctional: item.nonFunctional,
      reTry: 0,
      active:	true,
      reviewed : item.reviewed
    };

    this.selectedTestCases.push(obj);

  }

  removeAssocTestCase(item: any) {
    const index = this.selectedTestCases.indexOf(item);
    if (index > -1) {
      this.selectedTestCases.splice(index, 1);
    }
  }

  onReset() {
    this.submitted = false;
  }
  setRetryAndDelay() {
    this.selectedTestCases = this.selectedTestCases.map(testCase => ({
      ...testCase,
      reTry: 0,
      delay: 0
    }));
  }

  onSubmit() {
    this.submitted = true;
    if (this.webAutomationTool === 'PLAYWRIGHT') {
      this.setRetryAndDelay();
    }
    if (this.route.snapshot.params.id) {
      const data = { ...this.updateData};
      this.updateEndpoint(data);
    }
  }

  isAssociated(id: number) {
    let found = false;
    for (let index = 0; index < this.selectedTestCases.length; index++) {
      const elem = this.selectedTestCases[index];
      if (elem.testCaseId === id) {
        found = true;
      }
    }
    return found;
  }

  updateEndpoint(params: any) {
    const projectId = params.project.id;

    params.project = {
      id: projectId
    };

    if (this.selectedTestCases.length <= 0) {
      return;
    } else {
      if (this.webAutomationTool === 'PLAYWRIGHT') {
        params.desktopTestSuite = false;
        params.mobileTestSuite = false;
      }
      this.testsuiteservice.updateTestSuitesCases(params).pipe().subscribe(data => {
        if (data.code === 409) { } else if (data.code === 200) {
          this.testsuiteservice.associateDisassociateTestCases(data.response.id, this.selectedTestCases).subscribe((resp: any) => {
            this.toastr.success(data.message);
            this.router.navigateByUrl('testsuite/' + this.route.snapshot.params.id);
          });
        }
      });
    }
  }


  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.selectedTestCases, event.previousIndex, event.currentIndex);
  }


  

}